module.exports = __webpack_public_path__ + "media/packs/images/partners/partner-logo1-1c98a2cb232e7af9dc0f274b6f3049be.jpg";